module.exports = __webpack_public_path__ + "img/MG_4723b-scaled.8b1e9ae3.jpg";